var _path, _circle, _ellipse, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g, _line, _line2, _line3, _line4, _line5, _line6, _line7, _path2, _rect9, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _circle3, _path9, _path10, _g3, _circle4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostidentIntro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 310,
    viewBox: "0 0 454 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 174.613C-6.0574e-05 201.869 22.8556 266.961 72.2953 295.592C122.777 324.825 165.101 300.365 224.632 301.33C269.596 302.058 297.305 314.988 339.788 301.33C399.898 282.004 465.116 248.87 451.329 191.349C441.741 151.347 396.081 151.996 367.673 120.579C339.335 89.2384 342.374 56.8818 307.255 32.1166C231.235 -21.4914 138.522 18.6758 67.6478 78.0215C31.6352 108.176 6.05743e-05 147.357 0 174.613Z",
    fill: "#EF476F",
    fillOpacity: 0.02
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 238.212,
    cy: 83.9353,
    r: 50.9353,
    stroke: "#EF476F",
    strokeOpacity: 0.2,
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.8922,
    cy: 82.2802,
    rx: 84.8922,
    ry: 82.2802,
    transform: "matrix(-1 0 0 1 210.784 112.668)",
    stroke: "#EF476F",
    strokeOpacity: 0.2,
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.795,
    cy: 207.356,
    r: 34.6099,
    stroke: "#EF476F",
    strokeOpacity: 0.2,
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 137.274,
    y: 69.238,
    width: 15.5108,
    height: 3.08198,
    transform: "rotate(-45 137.274 69.238)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 330.274,
    y: 123.238,
    width: 15.5108,
    height: 3.08198,
    transform: "rotate(-45 330.274 123.238)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 161.274,
    y: 285.238,
    width: 15.5108,
    height: 3.08198,
    transform: "rotate(-45 161.274 285.238)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 405.274,
    y: 240.238,
    width: 15.5108,
    height: 3.08198,
    transform: "rotate(-45 405.274 240.238)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 139.333,
    y: 58,
    width: 16.0406,
    height: 3.29904,
    transform: "rotate(45 139.333 58)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 332.333,
    y: 112,
    width: 16.0406,
    height: 3.29904,
    transform: "rotate(45 332.333 112)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 163.333,
    y: 274,
    width: 16.0406,
    height: 3.29904,
    transform: "rotate(45 163.333 274)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 407.333,
    y: 229,
    width: 16.0406,
    height: 3.29904,
    transform: "rotate(45 407.333 229)",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.214 85.918C170.214 83.7088 172.005 81.918 174.214 81.918H281.333C282.4 81.918 283.422 82.3439 284.173 83.1011L293 92L302.235 101.331C302.977 102.08 303.392 103.091 303.392 104.145V247.632C303.392 249.841 301.602 251.632 299.392 251.632H174.214C172.005 251.632 170.214 249.841 170.214 247.632V85.918Z",
    fill: "white"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 231.499,
    y1: 172.5,
    x2: 279.499,
    y2: 172.5,
    stroke: "#EF476F",
    strokeOpacity: 0.75,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 231.499,
    y1: 162.5,
    x2: 279.499,
    y2: 162.5,
    stroke: "#EF476F",
    strokeOpacity: 0.75,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 232.499,
    y1: 181.5,
    x2: 258.499,
    y2: 181.5,
    stroke: "#EF476F",
    strokeOpacity: 0.75,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 196.5,
    y1: 108.5,
    x2: 229.916,
    y2: 108.5,
    stroke: "#EF476F",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 195.5,
    y1: 122.464,
    x2: 279.5,
    y2: 122.464,
    stroke: "#EF476F",
    strokeOpacity: 0.75,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 196.63,
    y1: 131.5,
    x2: 243.344,
    y2: 131.5,
    stroke: "#EF476F",
    strokeOpacity: 0.75,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 241.499,
    y1: 231.5,
    x2: 280.499,
    y2: 231.5,
    stroke: "#B3BAD3",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M278.389 220.647C277.757 220.976 276.992 220.556 276.931 219.845L276.493 214.733C276.425 213.938 277.272 213.387 277.971 213.772L282.959 216.513C283.659 216.898 283.648 217.908 282.939 218.277L278.389 220.647Z",
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 308.693,
    y: 154,
    width: 9.42857,
    height: 68.3571,
    rx: 2,
    transform: "rotate(28.7957 308.693 154)",
    fill: "#FFB484"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M311.792 155.703L315.203 157.578C316.171 158.11 316.525 159.326 315.993 160.294L284.993 216.693C284.461 217.661 283.245 218.015 282.277 217.483L281.964 217.311L311.792 155.703Z",
    fill: "#F29559"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.567 219.823C277.518 219.994 276.702 220.789 277.253 221.104L278.695 221.931C278.922 222.061 279.308 222.058 279.701 221.958C279.764 222.286 280.111 222.522 280.712 222.577L298.759 224.215C299.859 224.315 301.392 223.771 302.183 223.001L302.807 222.393C303.598 221.622 303.347 220.916 302.247 220.816L284.201 219.177C283.6 219.122 282.87 219.26 282.202 219.522C282.062 219.374 281.749 219.307 281.315 219.377L278.567 219.823Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M246.999 225.894C249.92 224.903 251.845 222.18 253.476 220.083C256.662 215.987 258.861 211.47 259.457 206.595C259.486 206.361 259.504 205.696 259.351 205.894C258.638 206.819 258.392 208.197 258.077 209.227C256.813 213.36 255.665 217.617 255.953 221.911C256.096 224.042 257.579 223.054 258.856 222C261.252 220.02 263.736 217.753 265.456 215.319C265.548 215.189 266.036 213.93 265.748 214.581C264.875 216.557 263.939 218.5 263.669 220.614C263.581 221.302 263.065 223.598 264.041 224.08C265.404 224.753 267.275 222.628 267.907 221.97C269.009 220.826 269.896 219.539 270.376 218.121C270.396 218.06 270.163 219.485 270.093 219.802C269.868 220.818 268.379 225.934 271.402 225.436C273.866 225.03 274.908 222.677 276.463 221.38",
    stroke: "#FF92AC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283 102L303 103L282 82L283 102Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115 87C115 91.9706 110.971 96 106 96C104.197 96 102.518 95.4699 101.11 94.5571L113.557 82.1103C114.47 83.5182 115 85.1972 115 87ZM98.5712 92.0822L111.082 79.5712C109.636 78.58 107.886 78 106 78C101.029 78 97 82.0294 97 87C97 88.8857 97.58 90.636 98.5712 92.0822ZM119 87C119 94.1797 113.18 100 106 100C98.8203 100 93 94.1797 93 87C93 79.8203 98.8203 74 106 74C113.18 74 119 79.8203 119 87Z",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339 268C339 272.971 334.971 277 330 277C328.197 277 326.518 276.47 325.11 275.557L337.557 263.11C338.47 264.518 339 266.197 339 268ZM322.571 273.082L335.082 260.571C333.636 259.58 331.886 259 330 259C325.029 259 321 263.029 321 268C321 269.886 321.58 271.636 322.571 273.082ZM343 268C343 275.18 337.18 281 330 281C322.82 281 317 275.18 317 268C317 260.82 322.82 255 330 255C337.18 255 343 260.82 343 268Z",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M298.342 69.2614C298.169 68.6257 298.648 68 299.307 68H309.693C310.352 68 310.831 68.6257 310.658 69.2614L305.465 88.4361C305.199 89.4209 303.801 89.4209 303.535 88.4361L298.342 69.2614Z",
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.5,
    cy: 96.5,
    r: 3.5,
    fill: "#EF476F",
    fillOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.483 103C127.491 85.6666 152.509 85.6667 162.517 103L217.076 197.5C227.084 214.833 214.574 236.5 194.56 236.5H85.4404C65.4255 236.5 52.9163 214.833 62.9237 197.5L117.483 103Z",
    fill: "#EF476F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.668 110.686C135.517 104.019 145.14 104.019 148.989 110.686L204.105 206.15C207.954 212.817 203.143 221.15 195.445 221.15H85.212C77.5141 221.15 72.7028 212.817 76.5518 206.15L131.668 110.686Z",
    stroke: "white",
    strokeWidth: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.469 132.532C148.936 132.532 155.21 140.397 153.329 148.652L146.753 177.516C146.085 180.449 143.477 182.529 140.469 182.529C137.462 182.529 134.854 180.449 134.186 177.516L127.61 148.652C125.729 140.397 132.003 132.532 140.469 132.532Z",
    fill: "white"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 198,
    r: 8,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2_7",
    x: 162.214,
    y: 77.918,
    width: 149.179,
    height: 188.714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.614167 0 0 0 0 0.614167 0 0 0 0 0.733333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_7"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.319965 0 0 0 0 0.338587 0 0 0 0 0.404167 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2_7",
    result: "effect2_dropShadow_2_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2_7",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2_7",
    x: 279,
    y: 81,
    width: 27,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.832587 0 0 0 0 0.851891 0 0 0 0 0.920833 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_7",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2_7",
    x: 107.274,
    y: 132.532,
    width: 66.3896,
    height: 89.9968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.716667 0 0 0 0 0.0836111 0 0 0 0 0.234339 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_7",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostidentIntro);
export default __webpack_public_path__ + "static/media/postident-intro.4ea766ca919c8d92699273feef870c7d.svg";
export { ForwardRef as ReactComponent };